module.exports = __webpack_public_path__ + "img/ac.a492d33c.png";